const swiperDiscoverOurHqCards = {
    swiperInstance: null,
    init: () => {
        import('swiper/bundle').then(({Swiper}) => {
            let domEls = document.querySelectorAll('.js-swiper-discover-our-hq-cards');
            if (domEls) {
                const params = getSwiperParams();
                domEls.forEach(el => {
                    swiperDiscoverOurHqCards.swiperInstance = new Swiper(el, params);
                })
            }
        })
    }
};

const getSwiperParams = () => {

    return {
        watchOverflow: true,
        centeredSlides: false,
        spaceBetween: 32,
        slidesPerView: 1,
        slideToClickedSlide: true,
        resizeObserver: true,
        a11y: true,
        mousewheel: {
            forceToAxis: true
        },
        grabCursor: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'progressbar',
        },
        breakpoints: {
            768: {
                slidesPerView: 2
            },
            1024: {
                slidesPerView: 3.5
            }
        }
    }
}

export default swiperDiscoverOurHqCards;